import { render, staticRenderFns } from "./historyComponent.vue?vue&type=template&id=5d77a5d2&scoped=true"
import script from "./historyComponent.vue?vue&type=script&lang=js"
export * from "./historyComponent.vue?vue&type=script&lang=js"
import style0 from "./historyComponent.vue?vue&type=style&index=0&id=5d77a5d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d77a5d2",
  null
  
)

export default component.exports